module.exports = __webpack_public_path__ + "static/img/31.5af95fa3.png";